<div class="row">
    <div class="col-md-12 col-xs-12 mb-1">
        <sc-title class="auto-plan-downloads--title" type="h2" content="Impresión"></sc-title>
    </div>

    <div class="col-md-12 col-xs-12">
            <ul class="li-block-container">
                    <li class="li-block with-icon" #liPoliza id="liPoliza" [ngClass]="{ 'dowload-blocked': (waitForPolicyWithoutClauses || waitForCertificate) }"
                        [class.selected]="liPoliza.selected" (click)="selectDownloadItem(liPoliza)">
                        <sc-icon icon="shield" size="1_5" *ngIf="(!waitForPolicyWithoutClauses && !waitForCertificate)"></sc-icon>
                        <sc-icon icon="loading" size="1_25" *ngIf="(waitForPolicyWithoutClauses || waitForCertificate)"></sc-icon>
                        <span>
                            <ng-container>
                                Frente de póliza sin clausulas
                            </ng-container>
                        </span>
                    </li>
                    <li class="li-block with-icon" 
                        #liPolicyWithClauses id="liPolicyWithClauses" [ngClass]="{ 'dowload-blocked': waitForPolicyWithClauses }"
                        [class.selected]="liPolicyWithClauses.selected" (click)="selectDownloadItem(liPolicyWithClauses)">
                        <sc-icon icon="shield" size="1_25" *ngIf="!waitForPolicyWithClauses"></sc-icon>
                        <sc-icon icon="loading" size="1_25" *ngIf="waitForPolicyWithClauses"></sc-icon>
                        Frente de Póliza con Clausulas
                    </li>
                    <li class="li-block with-icon" 
                        #liTarjetaObligatoria id="liTarjetaObligatoria" [ngClass]="{ 'dowload-blocked': waitForMandatoryInsurance }"
                        [class.selected]="liTarjetaObligatoria.selected" (click)="selectDownloadItem(liTarjetaObligatoria)">
                        <sc-icon icon="loading" size="1_25" *ngIf="waitForMandatoryInsurance"></sc-icon>
                        <sc-icon icon="shield" size="1_25" *ngIf="!waitForMandatoryInsurance"></sc-icon>
                        Tarjeta Obligatoria
                    </li>
                    <li class="li-block with-icon" #liMercosur id="liMercosur" [ngClass]="{ 'dowload-blocked': waitForMercosur }"
                        [class.selected]="liMercosur.selected" (click)="selectDownloadItem(liMercosur)">
                        <sc-icon icon="loading" size="1_25" *ngIf="waitForMercosur"></sc-icon>
                        <sc-icon icon="certificate" size="1_25" *ngIf="!waitForMercosur"></sc-icon>
                        <span>Certificado Mercosur (carta verde)</span>
                    </li>
                    <li class="li-block with-icon" #liCupones id="liCupones" [ngClass]="{ 'dowload-blocked': (waitForCoupons || waitForReceiptPayment) }"
                        [class.selected]="liCupones.selected" (click)="selectDownloadItem(liCupones)" >
                        <sc-icon icon="loading" size="0_75" *ngIf="waitForCoupons || waitForReceiptPayment"></sc-icon>
                        <sc-icon icon="efetivo" size="1" *ngIf="(!waitForCoupons && !waitForReceiptPayment)"></sc-icon>
                        <span>
                            Primer cupón de pago
                        </span>
                    </li>
                    <li class="li-block with-icon" #liPolicyChange id="liPolicyChange" [ngClass]="{ 'dowload-blocked': (waitForPolicyChange) }"
                        [class.selected]="liPolicyChange.selected" (click)="selectDownloadItem(liPolicyChange)" >
                        <sc-icon icon="loading" size="0_75" *ngIf="waitForPolicyChange"></sc-icon>
                        <sc-icon icon="efetivo" size="1" *ngIf="(!waitForPolicyChange)"></sc-icon>
                        <span>
                            Endoso de re-facturación
                        </span>
                    </li>
                </ul>
    </div>
</div>